export default __webpack_public_path__ + "static/media/social-share.755d13bc.svg";